import { getTranslations } from './getTranslations.js';

/**
 * Metodo que se encarga de cargar las traducciones.
 *
 * @returns {Promise<>}
 */
export async function configTranslations() {
  /** Recuperamos la locale */
  edicom.locale.id = document?.documentElement?.lang ?? 'es';

  /** Creamos la lista de idiomas que vamos a cargar, cargamos siempre 'es' y 'en' como fallbacks */
  const locales = [...new Set(['es', 'en', edicom.locale.id])];

  const promises = locales.map(async (locale) => {
    const translations = await getTranslations(locale);

    edicom.locale.translations(locale, translations);
  });

  return Promise.all(promises);
}
